import { ActionSheetOptions } from '@expo/react-native-action-sheet'
import { usePhotoUpload } from '@src/utils/hooks'
import { ReactNativeFile } from '@src/utils/image'
import { pickDocument } from '@src/utils/document'
import { useApplicationActionSheet } from './useApplicationActionSheet'

export enum ImageRequestActionSheetOption {
  ChooseFromLibrary = 'Choose from photo library',
  TakePhoto = 'Take photo',
  ChooseFile = 'Choose file',
}

interface ShowImageRequestActionSheetParams {
  title?: string
  options: ImageRequestActionSheetOption[]
  actionSheetStyleOptions?: Omit<ActionSheetOptions, 'options'>
}

export const useImageRequestActionSheet = (onPhotoReceived: (photo: ReactNativeFile) => void) => {
  const { showActionSheet } = useApplicationActionSheet<ImageRequestActionSheetOption>()
  const { launchCameraScreen, launchImageLibrary } = usePhotoUpload(onPhotoReceived)

  const showImageRequestActionSheet = ({
    title = 'Select Photo',
    options,
    actionSheetStyleOptions,
  }: ShowImageRequestActionSheetParams) => {
    showActionSheet({
      title,
      options,
      actionSheetStyleOptions,
      callback: (option: ImageRequestActionSheetOption) => {
        switch (option) {
          case ImageRequestActionSheetOption.ChooseFromLibrary:
            launchImageLibrary()
            break
          case ImageRequestActionSheetOption.TakePhoto:
            launchCameraScreen()
            break
          case ImageRequestActionSheetOption.ChooseFile:
            pickDocument(onPhotoReceived)
            break
        }
      },
    })
  }

  return { showImageRequestActionSheet }
}
